export const features = [
  {
    title: "Booster Cookie",
    description:
      "      Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam error iure aliquam temporibus voluptate ut tempore dignissimos optio provident eos!",
    url: "https://ironcodestudio.com/wp-content/uploads/2015/03/css-remove-horizontal-scrollbar.jpg",
  },
  {
    title: "Builder Wand",
    description:
      "      Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam error iure aliquam temporibus voluptate ut tempore dignissimos optio provident eos!",
    url: "https://media.discordapp.net/attachments/1083438619886354513/1086636521026764800/Screenshot_20230317-210236_Minecraft.jpg",
  },
  {
    title: "Custom Items",
    description:
      "      Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam error iure aliquam temporibus voluptate ut tempore dignissimos optio provident eos!",
    url: "https://ironcodestudio.com/wp-content/uploads/2015/03/css-remove-horizontal-scrollbar.jpg",
  },
  {
    title: "Bank",
    description:
      "      Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam error iure aliquam temporibus voluptate ut tempore dignissimos optio provident eos!",
    url: "https://ironcodestudio.com/wp-content/uploads/2015/03/css-remove-horizontal-scrollbar.jpg",
  },

  {
    title: "Daily Rewards",
    description:
      "      Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam error iure aliquam temporibus voluptate ut tempore dignissimos optio provident eos!",
    url: "https://ironcodestudio.com/wp-content/uploads/2015/03/css-remove-horizontal-scrollbar.jpg",
  },
  {
    title: "Kits",
    description:
      "      Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam error iure aliquam temporibus voluptate ut tempore dignissimos optio provident eos!",
    url: "https://ironcodestudio.com/wp-content/uploads/2015/03/css-remove-horizontal-scrollbar.jpg",
  },
];
